module.exports = __webpack_public_path__ + "static/img/公司14.f576549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司14.jpg
// module id = KC9T
// module chunks = 1